<template>

    <multiselect
        v-model="adviser"
        :options="advisers.list"
        track-by="uuid"
        :customLabel="(adviser) => (`${adviser.firstname} ${adviser.lastname}`)"
        :multiple="false"
        :allowEmpty="true"
        placeholder="Asesor"
        selectedLabel=""
        selectLabel=""
        deselectLabel=""
        @select="notifyChange">
    </multiselect>

</template>

<script>

    import Multiselect from 'vue-multiselect';
    import {mapState} from 'vuex'

    export default {

        name: "AdviserSelector",

        props: {
            value: Object
        },

        components: {
            Multiselect
        },

        data: function () {
            return {
                adviser: (!!this.value && !!this.value.uuid) ? this.value : null
            }
        },

        mounted() {
            this.$store.dispatch('loadAdvisers');
        },

        computed: {
            ...mapState([
                'advisers'
            ])
        },

        methods: {
            notifyChange(adviser) {
                this.$emit('input', adviser);
            }
        }
    }
</script>